export const doorsUsageInfo = {
  data: {
    doors: [
      {
        door: 1,
        status: "LDDK",
        inUseByInfo: {
          id: 52192,
          type: "Lane",
          name: "AFW",
          status: "LDDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 2,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: true,
      },
      {
        door: 3,
        status: "LDDK",
        inUseByInfo: {
          id: 52175,
          type: "Lane",
          name: "",
          status: "",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 4,
        status: "CLDK",
        inUseByInfo: {
          id: 40075623,
          type: "Trap",
          name: "Trap-2025-03-11-1",
          status: "CLDK",
          loadSummary: {
            bills: 1,
            weight: 450,
            pallets: 1,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 5,
        status: "CLDK",
        inUseByInfo: {
          id: 10003751,
          type: "Route",
          name: "BORDER-1",
          status: "CLDK",
          loadSummary: {
            bills: 2,
            weight: 759,
            pallets: 2,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 6,
        status: "CLDK",
        inUseByInfo: {
          id: 40075625,
          type: "Trap",
          name: "Trap-2025-04-11-1",
          status: "CLDK",
          loadSummary: {
            bills: 1,
            weight: 880,
            pallets: 2,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 7,
        status: "CLDK",
        inUseByInfo: {
          id: 3102688,
          type: "Route",
          name: "LA MIRADA",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 8,
        status: "LDDK",
        inUseByInfo: {
          id: 3102037,
          type: "Trip",
          name: "FRI: TRANSCO LINES, INC (ONT/AFW) PU 0600/SUN",
          status: "ENRT",
          loadSummary: {
            bills: 50,
            weight: 37678,
            pallets: 59,
            pieces: 120,
          },
        },
        isPlanned: false,
      },
      {
        door: 9,
        status: "CLDK",
        inUseByInfo: {
          id: 3102687,
          type: "Route",
          name: "ANAHEIM",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 10,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: true,
      },
      {
        door: 11,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: true,
      },
      {
        door: 12,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: true,
      },
      {
        door: 13,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: true,
      },
      {
        door: 14,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: true,
      },
      {
        door: 15,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: true,
      },
      {
        door: 16,
        status: "CLDK",
        inUseByInfo: {
          id: 3102698,
          type: "Route",
          name: "GARDEN GROVE",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 17,
        status: "LDDK",
        inUseByInfo: {
          id: 52180,
          type: "Lane",
          name: "",
          status: "LDDK",
          loadSummary: {
            bills: 3,
            weight: 4310,
            pallets: 4,
            pieces: 60,
          },
        },
        isPlanned: false,
      },
      {
        door: 18,
        status: "CLDK",
        inUseByInfo: {
          id: 3102689,
          type: "Route",
          name: "ALOHA",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 19,
        status: "CLDK",
        inUseByInfo: {
          id: 88582,
          type: "Trap",
          name: "R-ONTGHOST14",
          status: "TRAP",
          loadSummary: {
            bills: 4,
            weight: 5874,
            pallets: 8,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 20,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 21,
        status: "CLDK",
        inUseByInfo: {
          id: 0,
          type: "Unknown",
          name: "",
          status: "",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 22,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: true,
      },
      {
        door: 23,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: true,
      },
      {
        door: 24,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 25,
        status: "CLDK",
        inUseByInfo: {
          id: 3102694,
          type: "Route",
          name: "ALOHA",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 26,
        status: "CLDK",
        inUseByInfo: {
          id: 3102685,
          type: "Route",
          name: "BORDER",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 27,
        status: "CLDK",
        inUseByInfo: {
          id: 3102692,
          type: "Route",
          name: "BORDER",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 28,
        status: "CLDK",
        inUseByInfo: {
          id: 3102690,
          type: "Route",
          name: "BORDER",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 29,
        status: "CLDK",
        inUseByInfo: {
          id: 3102626,
          type: "Route",
          name: "CHULA VISTA",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 30,
        status: "CLDK",
        inUseByInfo: {
          id: 3102710,
          type: "Route",
          name: "SANTA ANA",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 31,
        status: "CLDK",
        inUseByInfo: {
          id: 3102662,
          type: "Route",
          name: "SAN GABRIEL BT-1",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 32,
        status: "CLDK",
        inUseByInfo: {
          id: 3102711,
          type: "Route",
          name: "N. ONTARIO ",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 33,
        status: "CLDK",
        inUseByInfo: {
          id: 3102718,
          type: "Route",
          name: "SAN CLEMENTE",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 34,
        status: "CLDK",
        inUseByInfo: {
          id: 3102709,
          type: "Route",
          name: "GARDEN GROVE",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 35,
        status: "CLDK",
        inUseByInfo: {
          id: 3102719,
          type: "Route",
          name: "RIVERSIDE",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 36,
        status: "CLDK",
        inUseByInfo: {
          id: 3102712,
          type: "Route",
          name: "TUSTIN",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 37,
        status: "CLDK",
        inUseByInfo: {
          id: 3102708,
          type: "Route",
          name: "N. CHINO",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 38,
        status: "CLDK",
        inUseByInfo: {
          id: 3102645,
          type: "Route",
          name: "OC BT",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 39,
        status: "CLDK",
        inUseByInfo: {
          id: 3102659,
          type: "Route",
          name: "N. SD COUNTY BT",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 40,
        status: "CLDK",
        inUseByInfo: {
          id: 3102660,
          type: "Route",
          name: "S. SAN DIEGO BT",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 41,
        status: "CLDK",
        inUseByInfo: {
          id: 3102656,
          type: "Route",
          name: "BORDER",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 42,
        status: "CLDK",
        inUseByInfo: {
          id: 3102667,
          type: "Route",
          name: "VISTA",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 43,
        status: "CLDK",
        inUseByInfo: {
          id: 3102658,
          type: "Route",
          name: "SD MIRIMAR BT",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 44,
        status: "CLDK",
        inUseByInfo: {
          id: 3102644,
          type: "Route",
          name: "OAK HARBOR",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 45,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 46,
        status: "CLDK",
        inUseByInfo: {
          id: 88586,
          type: "Trap",
          name: "R-ONTGHOST30",
          status: "TRAP",
          loadSummary: {
            bills: 8,
            weight: 4130,
            pallets: 8,
            pieces: 1,
          },
        },
        isPlanned: false,
      },
      {
        door: 47,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 48,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 49,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 50,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 51,
        status: "CLDK",
        inUseByInfo: {
          id: 3102724,
          type: "Route",
          name: "SD MIRIMAR BT",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 52,
        status: "CLDK",
        inUseByInfo: {
          id: 3102657,
          type: "Route",
          name: "N. SAN DIEGO",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 53,
        status: "CLDK",
        inUseByInfo: {
          id: 3102629,
          type: "Route",
          name: "EL CAJON",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 54,
        status: "CLDK",
        inUseByInfo: {
          id: 3102631,
          type: "Route",
          name: "POWAY",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 55,
        status: "CLDK",
        inUseByInfo: {
          id: 3102665,
          type: "Route",
          name: "TEMECULA",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 56,
        status: "CLDK",
        inUseByInfo: {
          id: 3102646,
          type: "Route",
          name: "OCEANSIDE",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 57,
        status: "CLDK",
        inUseByInfo: {
          id: 3102655,
          type: "Route",
          name: "SAN CLEMENTE",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 58,
        status: "CLDK",
        inUseByInfo: {
          id: 3102638,
          type: "Route",
          name: "IRVINE ",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 59,
        status: "CLDK",
        inUseByInfo: {
          id: 3102636,
          type: "Route",
          name: "HUNTINGTON BEACH",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 60,
        status: "CLDK",
        inUseByInfo: {
          id: 3102666,
          type: "Route",
          name: "TUSTIN",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 61,
        status: "CLDK",
        inUseByInfo: {
          id: 3102619,
          type: "Route",
          name: "ANAHEIM",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 62,
        status: "CLDK",
        inUseByInfo: {
          id: 3102663,
          type: "Route",
          name: "SANTA ANA",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 63,
        status: "CLDK",
        inUseByInfo: {
          id: 3102649,
          type: "Route",
          name: "ORANGE-1",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 64,
        status: "CLDK",
        inUseByInfo: {
          id: 3102622,
          type: "Route",
          name: "BREA",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 65,
        status: "CLDK",
        inUseByInfo: {
          id: 3102634,
          type: "Route",
          name: "N. ANAHEIM",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 66,
        status: "CLDK",
        inUseByInfo: {
          id: 3102635,
          type: "Route",
          name: "GARDEN GROVE",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 67,
        status: "CLDK",
        inUseByInfo: {
          id: 3102640,
          type: "Route",
          name: "LONG BEACH BT",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 68,
        status: "CLDK",
        inUseByInfo: {
          id: 3102623,
          type: "Route",
          name: "CARSON",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 69,
        status: "CLDK",
        inUseByInfo: {
          id: 3102627,
          type: "Route",
          name: "COMPTON",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 70,
        status: "CLDK",
        inUseByInfo: {
          id: 3102641,
          type: "Route",
          name: "N. LONG BEACH",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 71,
        status: "CLDK",
        inUseByInfo: {
          id: 3102722,
          type: "Route",
          name: "LONG BEACH BT",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 72,
        status: "CLDK",
        inUseByInfo: {
          id: 3102624,
          type: "Route",
          name: "CERRITOS",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 73,
        status: "CLDK",
        inUseByInfo: {
          id: 3102639,
          type: "Route",
          name: "LA MIRADA",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 74,
        status: "CLDK",
        inUseByInfo: {
          id: 3102664,
          type: "Route",
          name: "SANTA FE SPRINGS",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 75,
        status: "CLDK",
        inUseByInfo: {
          id: 3102669,
          type: "Route",
          name: "WHITTIER-1",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 76,
        status: "CLDK",
        inUseByInfo: {
          id: 3102620,
          type: "Route",
          name: "AZUSA",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 77,
        status: "CLDK",
        inUseByInfo: {
          id: 3102630,
          type: "Route",
          name: "EL MONTE",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 78,
        status: "CLDK",
        inUseByInfo: {
          id: 3102668,
          type: "Route",
          name: "WALNUT-1",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 79,
        status: "CLDK",
        inUseByInfo: {
          id: 3102637,
          type: "Route",
          name: "WALNUT",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 80,
        status: "CLDK",
        inUseByInfo: {
          id: 3102695,
          type: "Route",
          name: "S. CHINO",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 81,
        status: "CLDK",
        inUseByInfo: {
          id: 3102625,
          type: "Route",
          name: "N. CHINO",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 82,
        status: "CLDK",
        inUseByInfo: {
          id: 3102661,
          type: "Route",
          name: "SAN DIMAS-1",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 83,
        status: "CLDK",
        inUseByInfo: {
          id: 3102651,
          type: "Route",
          name: "POMONA",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 84,
        status: "CLDK",
        inUseByInfo: {
          id: 3102628,
          type: "Route",
          name: "CORONA",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 85,
        status: "CLDK",
        inUseByInfo: {
          id: 3102642,
          type: "Route",
          name: "MIRA LOMA",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 86,
        status: "CLDK",
        inUseByInfo: {
          id: 3102652,
          type: "Route",
          name: "RANCHO CUCAMONGA",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 87,
        status: "CLDK",
        inUseByInfo: {
          id: 3102648,
          type: "Route",
          name: "N. ONTARIO ",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 88,
        status: "CLDK",
        inUseByInfo: {
          id: 3102647,
          type: "Route",
          name: "ONTARIO",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 89,
        status: "CLDK",
        inUseByInfo: {
          id: 3102632,
          type: "Route",
          name: "FONTANA",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 90,
        status: "CLDK",
        inUseByInfo: {
          id: 3102633,
          type: "Route",
          name: "FONTANA NORTH -1",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 91,
        status: "CLDK",
        inUseByInfo: {
          id: 3102654,
          type: "Route",
          name: "S. BERNARDINO",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 92,
        status: "CLDK",
        inUseByInfo: {
          id: 3102653,
          type: "Route",
          name: "RIVERSIDE",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 93,
        status: "CLDK",
        inUseByInfo: {
          id: 3102643,
          type: "Route",
          name: "MORENO VALLEY-1",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 94,
        status: "CLDK",
        inUseByInfo: {
          id: 3102716,
          type: "Route",
          name: "S. BERNARDINO",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 95,
        status: "CLDK",
        inUseByInfo: {
          id: 3102618,
          type: "Route",
          name: "ALL FREIGHT",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: true,
      },
      {
        door: 96,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: true,
      },
      {
        door: 97,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 98,
        status: "LDDK",
        inUseByInfo: {
          id: 52184,
          type: "Lane",
          name: "",
          status: "LDDK",
          loadSummary: {
            bills: 2,
            weight: 1147,
            pallets: 2,
            pieces: 4,
          },
        },
        isPlanned: false,
      },
      {
        door: 99,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 100,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 101,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 102,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 103,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 104,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 105,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 106,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 107,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 108,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 109,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 110,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 111,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 112,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 113,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 114,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 115,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 116,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 117,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 118,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 119,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 120,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 121,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 122,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 123,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 124,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 125,
        status: "CLDK",
        inUseByInfo: {
          id: 3102621,
          type: "Route",
          name: "BENCHPRO",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 126,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 127,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 128,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 129,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 130,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 131,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 132,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 133,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 134,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 135,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 136,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 137,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 138,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 139,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 140,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 141,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 142,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 143,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 144,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 145,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 146,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 147,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 148,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 149,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 150,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 151,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 152,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 153,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 154,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 155,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 156,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 157,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 158,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 159,
        status: "CLDK",
        inUseByInfo: {
          id: 3102717,
          type: "Route",
          name: "HUNTINGTON BEACH",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 160,
        status: "CLDK",
        inUseByInfo: {
          id: 3102723,
          type: "Route",
          name: "TUSTIN",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 161,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 162,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 163,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 164,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 165,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 166,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 167,
        status: "CLDK",
        inUseByInfo: {
          id: 3102650,
          type: "Route",
          name: "ALOHA",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 168,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 169,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 170,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 171,
        status: "CLDK",
        inUseByInfo: {
          id: 3102703,
          type: "Route",
          name: "ANAHEIM",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 172,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 173,
        status: "CLDK",
        inUseByInfo: {
          id: 3102721,
          type: "Route",
          name: "LA MIRADA",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 174,
        status: "CLDK",
        inUseByInfo: {
          id: 3102720,
          type: "Route",
          name: "SANTA FE SPRINGS",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 175,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 176,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 177,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 178,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 179,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 180,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 181,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 182,
        status: "CLDK",
        inUseByInfo: {
          id: 3102691,
          type: "Route",
          name: "SANTA FE SPRINGS",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 183,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 184,
        status: "CLDK",
        inUseByInfo: {
          id: 3102743,
          type: "Route",
          name: "MIRA LOMA",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 185,
        status: "CLDK",
        inUseByInfo: {
          id: 3102742,
          type: "Route",
          name: "MIRA LOMA",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 186,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 187,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 188,
        status: "CLDK",
        inUseByInfo: {
          id: 0,
          type: "Unknown",
          name: "",
          status: "",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 189,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 190,
        status: "CLDK",
        inUseByInfo: {
          id: 0,
          type: "Unknown",
          name: "",
          status: "",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 191,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 192,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 193,
        status: "CLDK",
        inUseByInfo: {
          id: 0,
          type: "Unknown",
          name: "",
          status: "",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 194,
        status: "CLDK",
        inUseByInfo: {
          id: 3102701,
          type: "Route",
          name: "S. BERNARDINO",
          status: "CLDK",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 195,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 196,
        status: "CLDK",
        inUseByInfo: {
          id: 0,
          type: "Unknown",
          name: "",
          status: "",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 197,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 198,
        status: "CLDK",
        inUseByInfo: {
          id: 0,
          type: "Unknown",
          name: "",
          status: "",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 199,
        status: "CLDK",
        inUseByInfo: {
          id: 0,
          type: "Unknown",
          name: "",
          status: "",
          loadSummary: {
            bills: 0,
            weight: 0,
            pallets: 0,
            pieces: 0,
          },
        },
        isPlanned: false,
      },
      {
        door: 200,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 201,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 202,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 203,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
      {
        door: 204,
        status: "EMTY",
        inUseByInfo: null,
        isPlanned: false,
      },
    ],
  },
};
